export var ApiUrls;
(function (ApiUrls) {
    ApiUrls["Region"] = "/v1/regions/:regionId";
    ApiUrls["Districts"] = "/v2/geo/districts";
    ApiUrls["District"] = "/v1/geo/districts/:districtGuid";
})(ApiUrls || (ApiUrls = {}));
